<template>
  <div class="home">
    <div class="container-fluid">
      <!-- <Transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut"> -->
      <div class="personnal-informations-container hidden-print">
        <div class="wrapper">
          <UserInputForm :display-garanties="displayGaranties" @compute="processUserInput" @print="print" />
        </div>
      </div>
      <!-- </Transition> -->

      <Transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">
        <template v-if="displayResult">
          <div id="simulation-result" class="simulation-result-container">
            <div class="wrapper">
              <template v-if="displayGaranties">
                <div class="hidden-print">
                  <Disclaimer />
                </div>
              </template>

              <DisplayResult :userInput="userInput" :resultats="displayResult" :fullDisplay="fullDisplay" :display-garanties="displayGaranties" />

              <template v-if="displayGaranties">
                <div class="visible-print">
                  <div class="mt-5">
                    <Disclaimer />
                  </div>
                  <div class="mt-5">
                    <MentionsLegales />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </Transition>
    </div>
  </div>
</template>

<script>
import objectHelper from "@/classes/helpers/objectHelper";
import simulationService from "@/classes/services/simulationService";
import UserInformations from "@/classes/dto/userInformations";
import UserInputForm from "@/components/UserInputForm";
import DisplayResult from "@/components/DisplayResult";
import Disclaimer from "@/components/Disclaimer";
import MentionsLegales from "@/components/MentionsLegales";

export default {
  name: "HomeView",
  components: {
    UserInputForm,
    DisplayResult,
    Disclaimer,
    MentionsLegales,
  },
  data() {
    return {
      objectHelper,
      userInput: new UserInformations(),
      displayResult: undefined,
      fullDisplay: false,
      displayGaranties: true,
    };
  },
  methods: {
    processUserInput(event) {
      this.userInput = new UserInformations(event);
      this.displayResult = simulationService.compute(event);
    },
    print() {
      document.title = "MINFI - Ma simulation";
      this.fullDisplay = true;

      setTimeout(() => {
        window.print();

        setTimeout(() => {
          document.title = "MINFI";
          this.fullDisplay = false;
        }, 500);
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";
@import "@/assets/styles/_mixins.scss";

$wrapper-base-width: 1000px;
$bs-gutter-x: 1.5rem;
$bs-gutter-y: 0;

.personnal-informations-container,
.simulation-result-container {
  margin-top: calc($bs-gutter-y * -1);
  margin-right: calc($bs-gutter-x * -0.5);
  margin-left: calc($bs-gutter-x * -0.5);

  .wrapper {
    max-width: $wrapper-base-width;
    margin: 0 auto;
    padding: 1.5rem 0;

    @media (max-width: $screen-md-max) {
      max-width: $screen-md-max !important;
    }

    @media (max-width: $screen-sm-max) {
      margin: 0rem auto !important;
      padding: 2rem 0;
      border-radius: 0 !important;

      max-width: $screen-sm-max !important;
    }

    @media (max-width: $screen-xs-max) {
      max-width: $screen-xs-max !important;
    }
  }
}

.personnal-informations-container {
  .wrapper {
    margin-top: 1rem;
    margin-bottom: 10px;
    background: white url("@/assets/images/fond_vivinter.svg") right center no-repeat;
    background-size: auto 100%;
    @include shadow(5px);

    @media (max-width: $wrapper-base-width) {
      margin-top: 0;
      box-shadow: none;
      border-radius: 0;
    }

    @media (max-width: $screen-xs-max) {
      background: $gradient-siaci;
    }
  }
}

.simulation-result-container {
  .wrapper {
    $colToggleWidth: 1.25rem;

    @media (max-width: calc($screen-md-max + $colToggleWidth + 1rem)) {
      margin-right: 1rem;
      margin-left: calc($colToggleWidth / 2);
    }

    .alert {
      @media (max-width: $screen-md-max) {
        margin-right: 1rem !important;
      }
    }
  }
}
</style>
